module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-70"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-4 font-14"
  }, [_c('div', {
    staticClass: "ma-2"
  }, [_c('span', {
    staticClass: "font-18"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("notification.notifications")) + "\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "pointer hover-color right",
    on: {
      "click": _vm.markAllAsRead
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("notification.markAllAsRead")) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNothingMessage),
      expression: "isShowNothingMessage"
    }]
  }, [_c('div', {
    staticClass: "font-20 text-center"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("notification.nothingMessage")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-12 text-center"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("notification.mentionsMessage")) + "\n                            ")])]), _vm._v(" "), _c('div', [_vm._l((_vm.notificationList), function(notification, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2 px-3 py-3"
    }, [(notification.type == 'POST_UPVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.postUpvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'POST_DOWNVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.postDownvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'POST_COMMENT') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.postComment")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'COMMENT_UPVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.commentUpvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'COMMENT_DOWNVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.commentDownvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'COMMENT_REPLY') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.commentReply")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'USER_FOLLOW') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.userFollow")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (notification.type == 'USER_UNFOLLOW') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.userUnfollow")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_POST_UPDATE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminPostUpdate")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_POST_DELETE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminPostDelete")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_COMMENT_UPDATE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminCommentUpdate")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_COMMENT_DELETE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminCommentDelete")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e()])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    on: {
      "infinite": _vm.getNotificationList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2)], 1), _vm._v(" "), (false) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": "",
      "fill-height": ""
    }
  }, [_c('v-card', _vm._l((_vm.relatedUserInfoList), function(userInfo, index) {
    return _c('div', {
      key: index,
      staticClass: "ma-3 userDetail"
    }, [_c('div', {
      staticClass: "imgleft"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "52"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(userInfo.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.image != null),
        expression: "userInfo.image != null"
      }],
      attrs: {
        "src": userInfo.image,
        "alt": userInfo.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.image == null),
        expression: "userInfo.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(userInfo.userName.trim().substring(0, 1).toLocaleUpperCase()))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "right-side Author"
    }, [_c('div', {
      staticClass: "ml-3"
    }, [_c('span', {
      staticClass: "pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(userInfo.userName)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(userInfo.nickName))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(userInfo.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-500"
    }, [_vm._v("@" + _vm._s(userInfo.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.follow(userInfo)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.status == '0'),
        expression: "userInfo.status == '0'"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("common.follow")))])], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.status == '1'),
        expression: "userInfo.status == '1'"
      }]
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.unfollow")))])])])], 1)])])
  }), 0)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-243854dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Notification.vue
// module id = 421
// module chunks = 0